import {Component, Input} from '@angular/core';
import {PodState, PodValidation, PodValidationDeliveryType} from '../shared/pod-validation.model';
import {PodValidationDocument} from '../shared/pod-validation-document.model';
import {finalize} from 'rxjs/operators';
import {LoaderService} from '../../shared/services/loader.service';
import {PodValidationService} from '../shared/pod-validation.service';
import {ErrorHandlerService} from '../../shared/services/error-handler.service';
import {NavigationLinkService} from '../../shared/services/navigation-link.service';
import {PodValidationDeliveryItem} from '../shared/pod-validation-delivery-item.model';

@Component({
  selector: 'app-pods-validation-document',
  templateUrl: './pods-validation-document.component.html',
  styleUrls: ['./pods-validation-document.component.scss']
})
export class PodsValidationDocumentComponent {

  private _selectedPod: PodValidation;
  public acceptedFileTypes: string[] = PodValidationService.getPodValidationAcceptedTypes();
  public podDocument: PodValidationDocument;
  public PodState = PodState;
  public PodValidationDeliveryType = PodValidationDeliveryType;
  public editionOfProducts = false;
  private initialItemProductValues: PodValidationDeliveryItem[];
  public productsValid = true;

  @Input() public canEditProduct = false;
  @Input() public shouldDisplayEmptyPage = false;

  @Input()
  public set selectedPod(podValidation: PodValidation) {
    this._selectedPod = podValidation;
    this.podDocument = null;
    this.fetchPodDocument();
  }

  constructor(
    private loaderService: LoaderService,
    private podValidationService: PodValidationService,
    private errorHandlerService: ErrorHandlerService,
    public link: NavigationLinkService,
  ) {}

  public download(): void {
    const anchor = document.createElement('a');
    if (this.podDocument.downloadUrl.trim().length === 0) {
      anchor.download = this.podDocument.name;
      anchor.href = URL.createObjectURL(this.podDocument.content);
    } else {
      anchor.target = '_blank'
      anchor.href = this.podDocument.downloadUrl;
    }
    anchor.click();
  }

  public fetchPodDocument(): void {
    if (this._selectedPod == null) {
      return;
    }

    this.editionOfProducts = false;
    this.loaderService.startLoad();
    this.podValidationService.getPodDocument(this._selectedPod).pipe(
      finalize(() => this.loaderService.stopLoad())
    ).subscribe(podDocument => {
      this.podDocument = podDocument
      this.updateInitialItemProductValues();
    }, e => this.errorHandlerService.handleHttpError(e, 'pods-validation.errors.fetch-pod-document'));
  }

  private updateInitialItemProductValues(): void {
    this.initialItemProductValues = this._selectedPod.deliveryItems.map(di => PodValidationDeliveryItem.copy(di));
  }

  public podWasUploadedToTms() {
    return this.podDocument != null
      && this.podDocument.content == null
      && this.podDocument.downloadUrl != null
      && this.selectedPod.state === PodState.VALIDATED;
  }

  public editProducts(): void {
    this.editionOfProducts = true;
  }

  public cancelProductEdition(): void {
    this.editionOfProducts = false;
    this._selectedPod.deliveryItems = this.initialItemProductValues.map(di => PodValidationDeliveryItem.copy(di));
  }

  public saveProducts(): void {
    this.editionOfProducts = false;
    this.podValidationService.updateProducts(this._selectedPod)
      .pipe(finalize(() => this.updateInitialItemProductValues()))
      .subscribe();
  }

  public get selectedPod() {
    return this._selectedPod
  }
}
